/**
 * Variant Enhancements for BJØRG Jewellery
 * Ensures first available variant is preselected and improves variant availability display
 */

(function($) {
  'use strict';

  var VariantEnhancements = {
    init: function() {
      this.preselectFirstAvailableVariant();
      this.enhanceVariantDisplay();
      this.handleLowStockVariants();
    },

    preselectFirstAvailableVariant: function() {
      // Wait for DOM and variants to be fully loaded
      var self = this;
      
      // Run immediately
      self.selectFirstAvailable();
      
      // Use multiple triggers with more aggressive timing
      setTimeout(function() {
        self.selectFirstAvailable();
      }, 10);
      
      setTimeout(function() {
        self.selectFirstAvailable();
      }, 100);
      
      setTimeout(function() {
        self.selectFirstAvailable();
      }, 300);
      
      setTimeout(function() {
        self.selectFirstAvailable();
      }, 600);
      
      $(document).ready(function() {
        self.selectFirstAvailable();
      });
    },

    selectFirstAvailable: function() {
      console.log('DEBUG: selectFirstAvailable called');
      
      // Get variants JSON and inventory data
      var variantsJson = $('[id^="VariantsJson-"]').text();
      if (!variantsJson) {
        console.log('DEBUG: No variants JSON found');
        return;
      }
      
      var sectionId = $('[id^="VariantsJson-"]').attr('id').replace('VariantsJson-', '');
      var inventoryData = window.inventories ? window.inventories[sectionId] : null;
      
      try {
        var variants = JSON.parse(variantsJson);
        console.log('DEBUG: All variants:', variants);
        console.log('DEBUG: Inventory data:', inventoryData);
        
        // Find the first variant with inventory > 0
        var firstInStock = null;
        for (var i = 0; i < variants.length; i++) {
          var variant = variants[i];
          var inventory = inventoryData && inventoryData[variant.id] ? inventoryData[variant.id].quantity : variant.inventory_quantity;
          
          console.log('DEBUG: Variant', variant.id, '- Option1:', variant.option1, '- Available:', variant.available, '- Inventory:', inventory);
          
          if (variant.available && inventory > 0) {
            firstInStock = variant;
            console.log('DEBUG: Found first in-stock variant:', variant.id, '- Option:', variant.option1);
            break;
          }
        }
        
        // If no in-stock variant found, fall back to first available
        if (!firstInStock) {
          firstInStock = variants.find(function(v) { return v.available; });
          console.log('DEBUG: No in-stock found, using first available:', firstInStock ? firstInStock.id : 'none');
        }
        
        if (firstInStock) {
          // Find the input for this variant's option1 value
          var $variantWrap = $('.variant-input-wrap[data-index="option1"]');
          var $inputs = $variantWrap.find('input[type="radio"]');
          var $targetInput = $inputs.filter('[value="' + firstInStock.option1 + '"]');
          
          console.log('DEBUG: Looking for input with value:', firstInStock.option1);
          console.log('DEBUG: Found input:', $targetInput.length > 0);
          
          if ($targetInput.length) {
            // Uncheck all and remove any classes
            $inputs.prop('checked', false);
            $variantWrap.find('label').removeClass('force-selected');
            
            // Select the target input
            $targetInput.prop('checked', true);
            $targetInput.trigger('change');
            
            console.log('DEBUG: Selected first in-stock option:', firstInStock.option1);
            
            // Update URL with variant ID
            if (window.history && window.history.replaceState) {
              var url = new URL(window.location);
              url.searchParams.set('variant', firstInStock.id);
              window.history.replaceState({}, '', url);
              console.log('DEBUG: Updated URL with variant ID:', firstInStock.id);
            }
          }
        }
      } catch(e) {
        console.error('DEBUG: Error in selectFirstAvailable:', e);
      }
    },

    handleLowStockVariants: function() {
      var self = this;
      
      // Function to mark low stock variants
      var markLowStock = function() {
        // Get all variants data from the page
        var variantsJson = $('[id^="VariantsJson-"]').text();
        if (!variantsJson) {
          console.log('DEBUG: No variants JSON found');
          return;
        }
        
        try {
          var variants = JSON.parse(variantsJson);
          console.log('DEBUG: Total variants found:', variants.length);
          console.log('DEBUG: All variants:', variants);
          
          // Also check window.inventories
          console.log('DEBUG: window.inventories:', window.inventories);
          
          // Get the section ID from the variants JSON element
          var sectionId = $('[id^="VariantsJson-"]').attr('id').replace('VariantsJson-', '');
          console.log('DEBUG: Section ID:', sectionId);
          
          var inventoryData = window.inventories ? window.inventories[sectionId] : null;
          console.log('DEBUG: Inventory data for section:', inventoryData);
          
          variants.forEach(function(variant) {
            var variantInventory = inventoryData ? inventoryData[variant.id] : null;
            var quantity = variantInventory ? variantInventory.quantity : variant.inventory_quantity;
            
            console.log('DEBUG: Variant', variant.id, '- Option1:', variant.option1, '- Available:', variant.available, '- Inventory:', quantity);
            
            // Check if variant is available but has 0 or low inventory
            if (variant.available && quantity !== undefined && quantity <= 0) {
              console.log('DEBUG: Marking variant as low-stock:', variant.option1, 'Qty:', quantity);
              
              // Find the input for this specific variant option
              var optionValue = variant.option1;
              if (optionValue) {
                // More precise selector
                var $input = $('.variant-input-wrap[data-index="option1"] input[value="' + optionValue + '"]');
                var $label = $input.next('label');
                
                if ($label.length) {
                  $label.addClass('low-stock').attr('data-stock', quantity);
                  $label.css('pointer-events', 'auto');
                  console.log('DEBUG: Applied low-stock class to:', optionValue);
                } else {
                  console.log('DEBUG: Label not found for:', optionValue);
                }
              }
            }
          });
        } catch(e) {
          console.error('DEBUG: Error parsing variants JSON:', e);
        }
      };
      
      // Run after page load with delays
      setTimeout(function() {
        console.log('DEBUG: Running markLowStock (100ms delay)');
        markLowStock();
      }, 100);
      
      setTimeout(function() {
        console.log('DEBUG: Running markLowStock (500ms delay)');
        markLowStock();
      }, 500);
      
      // Re-apply after variant changes
      $(document).on('change', '.variant-input-wrap input[type="radio"]', function() {
        console.log('DEBUG: Variant changed, re-running markLowStock');
        setTimeout(markLowStock, 100);
      });
    },

    enhanceVariantDisplay: function() {
      // Function to update variant styling based on availability
      var updateVariantStyling = function() {
        $('.variant-input-wrap input[type="radio"]').each(function() {
          var $input = $(this);
          var $label = $input.next('label');
          
          if ($input.is(':disabled')) {
            $label.addClass('disabled');
            // Make sure disabled variants can't be selected
            $label.css('pointer-events', 'none');
          } else {
            $label.removeClass('disabled');
            // Ensure enabled variants are clickable
            if (!$label.hasClass('low-stock')) {
              $label.css('pointer-events', 'auto');
            }
          }
        });
      };

      // Initial styling update
      updateVariantStyling();
      
      // Update styling when variants change
      $(document).on('change', '.variant-input-wrap input[type="radio"]', function() {
        setTimeout(updateVariantStyling, 100);
      });
    }
  };

  // Initialize when document is ready
  $(document).ready(function() {
    VariantEnhancements.init();
    
    // Add listener for manual variant selection
    $(document).on('change', '.variant-input-wrap input[type="radio"]', function() {
      // Remove force-selected class from all labels in this variant group
      var $variantWrap = $(this).closest('.variant-input-wrap');
      $variantWrap.find('label').removeClass('force-selected');
      console.log('DEBUG: User manually selected variant, cleaned up classes');
    });
  });

  // Also initialize on theme events and after a delay to ensure variants are loaded
  $(document).on('shopify:section:load', function() {
    VariantEnhancements.init();
  });
  
  // Additional trigger after page load
  $(window).on('load', function() {
    setTimeout(function() {
      VariantEnhancements.init();
    }, 500);
  });

  // Watch for changes to variant selections and force first in-stock variant
  var checkInterval = setInterval(function() {
    var $sizeInputs = $('.variant-input-wrap[data-index="option1"] input[type="radio"]');
    if ($sizeInputs.length > 0) {
      // Get variant and inventory data to find first in-stock
      var variantsJson = $('[id^="VariantsJson-"]').text();
      if (variantsJson) {
        try {
          var variants = JSON.parse(variantsJson);
          var sectionId = $('[id^="VariantsJson-"]').attr('id').replace('VariantsJson-', '');
          var inventoryData = window.inventories ? window.inventories[sectionId] : null;
          
          // Find first in-stock variant
          var firstInStock = null;
          for (var i = 0; i < variants.length; i++) {
            var variant = variants[i];
            var inventory = inventoryData && inventoryData[variant.id] ? inventoryData[variant.id].quantity : variant.inventory_quantity;
            if (variant.available && inventory > 0) {
              firstInStock = variant;
              break;
            }
          }
          
          if (!firstInStock) {
            firstInStock = variants.find(function(v) { return v.available; });
          }
          
          if (firstInStock) {
            var $checked = $sizeInputs.filter(':checked');
            var $targetInput = $sizeInputs.filter('[value="' + firstInStock.option1 + '"]');
            
            if ($targetInput.length > 0 && (!$checked.length || $checked.val() !== firstInStock.option1)) {
              console.log('DEBUG: Interval check forcing first in-stock:', firstInStock.option1);
              $sizeInputs.prop('checked', false);
              $targetInput.prop('checked', true).trigger('change');
            }
          }
        } catch(e) {
          console.error('DEBUG: Error in interval check:', e);
        }
      }
      
      // Stop checking after 2 seconds
      setTimeout(function() {
        clearInterval(checkInterval);
        console.log('DEBUG: Stopped interval checking');
      }, 2000);
    }
  }, 100);

})(jQuery);
